import { protectedApi } from './requester'

export interface UpdateAdminDepartmentsRequest {
  username: string
  departments: string[]
}

export const updateAdminDepartments = async (
  request: UpdateAdminDepartmentsRequest,
): Promise<number> => {
  return protectedApi
    .patch<void>('/users/admin-departments', request)
    .then((response) => response.status)
}
